import React from 'react'
import OutlookKey from './OutlookKey'
import { onButtonTriggerKey, onEscapeKey } from '../../utils'

type Props = {
  handleClick: () => void
}

type State = {
  isOpen: boolean
}
class OutlookPopup extends React.Component<Props, State> {
  // @ts-ignore
  closeButton: HTMLElement | null = null

  constructor(props: Props) {
    super(props)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)
    this.state = {
      isOpen: true
    }
  }

  handleOverlayClick() {
    const { handleClick } = this.props
    handleClick()
    this.setState({ isOpen: false })
  }

  putFocusOnClose() {
    const { isOpen } = this.state
    if (isOpen && this.closeButton) {
      this.closeButton.focus()
    }
  }

  componentDidMount() {
    this.putFocusOnClose()
  }

  componentDidUpdate() {
    this.putFocusOnClose()
  }

  render() {
    const { handleClick } = this.props
    const { isOpen } = this.state

    if (!isOpen) {
      return null
    }

    return (
      <div
        className="frw-ratings-history-overlay"
        onClick={this.handleOverlayClick}
        onKeyDown={onButtonTriggerKey(() => this.handleOverlayClick())}
        role="presentation"
      >
        <div
          className="frw-outlook-popup"
          onClick={(event: any) => event.stopPropagation()}
          onKeyDown={onEscapeKey(() => this.handleOverlayClick())}
          role="presentation"
        >
          <span
            onClick={handleClick}
            onKeyDown={onButtonTriggerKey(handleClick)}
            tabIndex={0}
            role="button"
            ref={(e) => {
              this.closeButton = e
            }}
          >
            <i className="fas fa-times" />
          </span>
          <div className="frw-ratables-ratings-history-container">
            <OutlookKey />
          </div>
        </div>
      </div>
    )
  }
}

export default OutlookPopup
